/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { If, Then, When, Else } from "react-if";
import {
  Checkbox,
  Tooltip,
  SVGIcon,
  FlexContainer,
  theme,
  Text,
} from "@nordcloud/gnui";
import { toCamelCase, PathName } from "~/tools";
import { SidebarItemWrapper, SidebarIconWrap } from "../Styled";
import { SwitchWrap, ItemHeading } from "./styles";
import { SidebarItemProps, UISidebarProps } from "./types";

type Props = SidebarItemProps & UISidebarProps;

function iconsMapping(name: string): PathName {
  const iconNames: { [key: string]: string } = {
    Database: "databaseCategory",
    Service: "webServices",
    Miscellaneous: "other",
  };

  if (Object.keys(iconNames).includes(name)) {
    return iconNames[name] as PathName;
  }

  return toCamelCase(name) as PathName;
}

export function SidebarItem({
  hasSubtitle = false,
  hasIcon,
  item,
  name,
  onSubmit,
  selectedOptions,
}: Props) {
  return (
    <SidebarItemWrapper
      title={item?.value ?? ""}
      hasIcon={hasIcon}
      data-testid="sidebar-item"
      onClick={() => onSubmit(item.value ?? "")}
    >
      <SwitchWrap>
        <Checkbox
          withoutLabel
          checked={selectedOptions?.includes(item.value ?? "")}
        />
      </SwitchWrap>
      <If condition={hasSubtitle}>
        <Then>
          <When condition={hasIcon}>
            <SidebarIconWrap>
              <Tooltip
                status={item.status?.color}
                caption={item.status?.comment ?? ""}
                hideTimeout={0}
                minWidth={item.status?.width}
                position="left"
              >
                <SVGIcon
                  name={item.status?.name ?? "statusWarning"}
                  data-testid="sidebar-item-icon"
                />
              </Tooltip>
            </SidebarIconWrap>
          </When>
          <FlexContainer direction="column" alignItems="flex-start">
            <ItemHeading level={4}>{item?.label}</ItemHeading>
            <Text
              size="sm"
              tag="span"
              color={theme.color.text.text02}
              css={{ wordBreak: "break-all", textAlign: "left" }}
            >
              {item?.value}
            </Text>
          </FlexContainer>
        </Then>
        <Else>
          <When condition={name === "Resource Category"}>
            <SVGIcon size="smd" name={iconsMapping(item?.label ?? "other")} />
          </When>
          <ItemHeading level={5}>{item?.label}</ItemHeading>
        </Else>
      </If>
    </SidebarItemWrapper>
  );
}
